/* eslint-disable no-undef */
import { gsap } from 'gsap/dist/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {

    // /**************************************************************
    // -> Pageload animation
    // **************************************************************/
    function pageWishlistLandingLoadAnimation() {
      const tl = gsap.timeline({ delay: 0.5, duration: 0.5 })

      tl.to('.hero-template_wishlist-landing .wrap-fullscreen-image', { opacity: 1 })
      .to('.hero-template_wishlist-landing .dark-overlay-hero', { opacity: 1 }, '>-0.15')
      .to('.hero-template_wishlist-landing .wrap-hero-header h1', { opacity: 1 }, '>-0.25')
    }
    pageWishlistLandingLoadAnimation()

    /**************************************************************
    -> Your wishlist top anim on scroll
    **************************************************************/
    function inViewAnimIntroWishlistLanding() {
      gsap.fromTo('.wishlis-list-landing h4' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.wishlis-list-landing',
      })

      gsap.fromTo('.wishlis-list-landing .wrap-wishlist-list .wishlist-item' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.75,
        duration: 0.5,
        stagger: {
          each: 0.08,
          from: 'start',
          grid: 'auto',
          ease: 'linear',
        },
        scrollTrigger: '.wishlis-list-landing .wrap-wishlist-list',
      })
    }
    inViewAnimIntroWishlistLanding();

     /**************************************************************
    -> Form and experiences List anim on scroll
    **************************************************************/
    function inViewAnimFormAndList() {
      gsap.fromTo('.your-wishlist-form-and-list .wrap-form' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        scrollTrigger: '.your-wishlist-form-and-list',
      })

      gsap.fromTo('.your-wishlist-form-and-list .wrap-wishlist-list .wishlist-item' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.75,
        duration: 0.5,
        stagger: {
          each: 0.08,
          from: 'start',
          grid: 'auto',
          ease: 'linear',
        },
        scrollTrigger: '.your-wishlist-form-and-list',
      })

    }
    inViewAnimFormAndList();    

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/wishlist-landing.js